package nl.volleyplanner.web.util

import kotlinx.browser.document
import kotlinx.html.InputType
import org.w3c.dom.*
import org.w3c.dom.events.Event

fun HTMLInputElement.getStringValue() = value
fun HTMLInputElement.getIntValue() = value.toInt()
fun HTMLInputElement.getBooleanValue() : Boolean {
    return when (type) {
        InputType.checkBox.realValue -> checked
        else -> value.toBoolean()
    }
}

object FormUtil {
    fun toggleInputEnabled(inputHtmlId: String): (Event) -> Unit = { event ->
        val inputElement = document.getElementById(inputHtmlId)
        when (inputElement) {
            is HTMLSelectElement -> inputElement.disabled = !inputElement.disabled
            is HTMLInputElement -> inputElement.disabled = !inputElement.disabled
            is HTMLTextAreaElement -> inputElement.disabled = !inputElement.disabled
            is HTMLButtonElement -> inputElement.disabled = !inputElement.disabled
            is HTMLFieldSetElement -> inputElement.disabled = !inputElement.disabled
            is HTMLOptGroupElement -> inputElement.disabled = !inputElement.disabled
            is HTMLOptionElement -> inputElement.disabled = !inputElement.disabled
        }
    }
}
